import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from "@ngxs/store";
import { BehaviorSubject, combineLatest } from "rxjs";
import { IPharmacy } from "../interfaces/pharmacy.interface";
import { IUser } from "../interfaces/user.interface";
import { AuthState } from "../states/auth/auth.state";
import { PharmacyState } from "../states/pharmacy/pharmacy.state";
import { ProfileState } from "../states/profile/profile.state";
import { GetBeaconSignature } from "../states/profile/profile.actions";
import { distinctUntilChanged } from "rxjs/operators";

declare const window: any;

@UntilDestroy()
@Injectable()
export class CustomerSupportService {
    /**
     *
     */
    BEACON_ID: string = 'd9617d32-36ea-49b9-8248-49516c62145c';

    private beaconIsReady$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private store: Store) {
        
        window?.Beacon('on', 'ready', () => {
            setTimeout(() => {
                this.beaconIsReady$.next(true); 
                window.Beacon('open');
            });
        });
        
        combineLatest([
            this.store.select(PharmacyState.currentPharmacy), 
            this.store.select(AuthState.activeUser), 
            this.beaconIsReady$, 
            this.store.select(ProfileState.beaconSignature)
        ])
        .pipe(untilDestroyed(this))
        .subscribe(([
            pharmacy, 
            user, 
            beaconIsReady, 
            beaconSignature
        ]: [IPharmacy, IUser, boolean, string]) => {
            if (beaconIsReady && pharmacy && user && !!beaconSignature) {
                window.Beacon('reset');
                setTimeout(() => {
                    window?.Beacon('identify', {
                        name: user.firstName + ' ' + user.lastName,
                        email: user.email,
                        company: pharmacy.name,
                        signature: beaconSignature,
                        'pharmacynpi': pharmacy?.npiNumber,
                        'telephone': pharmacy?.phoneNumber,
                        'phone_number': pharmacy?.phoneNumber?.toString(),
                    });

                      window?.Beacon('prefill', {
                        fields: [
                          { id: 56011, value: pharmacy.name },
                          { id: 56014, value: pharmacy.npiNumber.toString() },
                          { id: 56013, value: pharmacy.phoneNumber },
                        ],
                    });

                });
              
                
            } else {
                this.close();
            }
        })

        this.store.select(AuthState.lockScreen)
        .pipe(untilDestroyed(this))
        .subscribe((locked) => {
            if (locked) {
                this.close();
            }
        });

        this.store.select(AuthState.activeUser)
        .pipe(untilDestroyed(this), distinctUntilChanged())
        .subscribe((user) => {
           if (user) {
            this.store.dispatch(new GetBeaconSignature());
           }
        })
    }

    toggle(): void {
        if (!window.Beacon('info')) {
            window?.Beacon('init', this.BEACON_ID);
        }
        else window?.Beacon('toggle');
    }

    close(): void {
        window?.Beacon('close');
    }

    logout(): void {
        window.Beacon('logout',  { endActiveChat: true });
        window.Beacon('destroy');
        this.beaconIsReady$.next(false);
    }
   
}